import { render, staticRenderFns } from "./ClerksNewDispatch.vue?vue&type=template&id=65066c90&scoped=true&"
import script from "./ClerksNewDispatch.vue?vue&type=script&lang=js&"
export * from "./ClerksNewDispatch.vue?vue&type=script&lang=js&"
import style0 from "./ClerksNewDispatch.vue?vue&type=style&index=0&id=65066c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65066c90",
  null
  
)

export default component.exports